/* eslint-disable */

/** CashInstrumentType represents the types of instruments that can be used within Cash. */
export enum CashInstrumentType {
  DEBIT_CARD = "DEBIT_CARD",
  BANK_ACCOUNT = "BANK_ACCOUNT",
  CREDIT_CARD = "CREDIT_CARD",
  CASH_BALANCE = "CASH_BALANCE",
  LINE_OF_CREDIT = "LINE_OF_CREDIT",
  APPLE_PAY = "APPLE_PAY",
}
